import { Link } from 'react-router';
import { getCategory } from '../data';

/**
 * カテゴリのトップページ (/<category>)。子要素 (環論、解答集など) の
 * 一覧を表示し、各子要素のトップページへ誘導する。
 */
export function CategoryPage({ categoryKey }: { categoryKey: string }) {
  const category = getCategory(categoryKey);
  return (
    <>
      <div className="hero">
        <h1>{category.title}</h1>
        <p>{category.lead}</p>
      </div>
      {category.children.map((child) => (
        <section className="card" key={child.key}>
          <h2>
            <Link to={`/${category.key}/${child.key}`}>{child.title}</Link>
          </h2>
          {child.description.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </section>
      ))}
    </>
  );
}
